import { LabelKey } from '@shared/models';
import { ElasticSearchResponse } from '@shared/services/elastic-search/models';

export const filterGenericSerializer = (filters: ElasticSearchResponse<unknown>): LabelKey[] => {
  return (
    filters.hits.hits.reduce<LabelKey[]>((accumulator, filter) => {
      const name = (filter?._source as { name?: string }).name?.[0];

      if (name) {
        accumulator.push({
          key: name,
          label: name,
        });
      }

      return accumulator;
    }, []) ?? []
  );
};
